import { render, staticRenderFns } from "./titleTextSetting.vue?vue&type=template&id=2fd3ea9a&scoped=true&"
import script from "./titleTextSetting.vue?vue&type=script&lang=js&"
export * from "./titleTextSetting.vue?vue&type=script&lang=js&"
import style0 from "./titleTextSetting.vue?vue&type=style&index=0&id=2fd3ea9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3ea9a",
  null
  
)

export default component.exports